// extracted by mini-css-extract-plugin
export var component = "RelatedContentRow-module--component--0ad36";
export var fadePop = "RelatedContentRow-module--fade-pop--a63c9";
export var growHeightIn = "RelatedContentRow-module--grow-height-in--3f2b9";
export var items = "RelatedContentRow-module--items--fd617";